class UserModalService {
    constructor(
        $http,
        appConfig
    ) {
        'ngInject';

        this.$http = $http;
        this.appConfig = appConfig;
    }

    updateUser(userId, clientIds, customPermissions) {
        const data = {
            client_ids: clientIds,
            custom_permission_ids: customPermissions
        };
        return this.$http.patch(`${this.appConfig.apiUrl}/users/${userId}/`, data);

    }

}

export default UserModalService;


// WEBPACK FOOTER //
// ./app/components/user-admin/user-modal/user-modal-service.js